import { ActionControllerEventName, ParentEvent, ResourcesManager, ResourceType, TextComponent, Viewer, ViewerModule, WindowComponent } from '@verybigthings/vbt-webvr-framework';
import { Euler, Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Quaternion, Vector2, Vector3 } from 'three';
import { InputManager } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/InputManager';
import { PRIMARY_TEXT_COLOR, WINDOW_HEADER_TEXT_BACKGROUND_COLOR, } from '../../../styleConfig';
import { Input } from '../../../components/Input';
export class Notebook extends ViewerModule {
    constructor() {
        super();
        this.isNearUser = false;
        window.addEventListener('keyup', (event) => {
            if (!this.activeInput)
                return;
            if (!isNaN(parseInt(event.key)) || event.key === '.')
                this.activeInput.addSymbol(event.key);
            if (event.key === 'Enter')
                this.activeInput.setEnter();
            if (event.key === 'Backspace')
                this.activeInput.deleteSymbol();
        });
        this.resourcesInUse.push({
            name: 'notebook',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/notebook.fbx')
        });
        this.inputSize = new Vector2(0.8 * 2, 0.8);
    }
    init(parentLevel) {
        this.parentLevel = parentLevel;
        const inputOptions = () => ({
            size: this.inputSize.clone(),
            pxSize: new Vector2(64 * 2, 64),
            background: 0xffffff,
            bordRadius: 0.01,
            maxLength: 4,
            text: {
                value: '',
                autoWrappingHorizontal: true,
                autoWrapping: false,
                style: { family: 'Nunito-Sans', weight: '700', size: '45px', color: PRIMARY_TEXT_COLOR.getStyle() },
                lineHeight: 45,
            }
        });
        const inputsWrapper = this.addObject(new Object3D());
        this.inputs = [
            {
                type: 'transmittance',
                wavelength: 380,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper),
            },
            {
                type: 'absorbance',
                wavelength: 380,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'transmittance',
                wavelength: 405,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'absorbance',
                wavelength: 405,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'transmittance',
                wavelength: 430,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'absorbance',
                wavelength: 430,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'transmittance',
                wavelength: 455,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
            {
                type: 'absorbance',
                wavelength: 455,
                input: this.addObject(new Input(inputOptions(), 'number'), null, inputsWrapper)
            },
        ];
        ViewerModule.adjustObjects(inputsWrapper.children, true, 3, 10);
        inputsWrapper.position.set(1.42, -0.14, -2.9);
        inputsWrapper.rotation.set(-1.58, 0, 0.397);
        const wrapLines = this.addObject(new Object3D());
        wrapLines.name = 'WrapLines';
        wrapLines.position.z = -0.08;
        wrapLines.rotation.set(-1.58, 0, 0.397);
        for (let i = 0; i < 7; i++) {
            wrapLines.add(new Mesh(new PlaneGeometry(12.8, .032), new MeshBasicMaterial({ color: 0xc7e6fc })));
        }
        ViewerModule.adjustObjects(wrapLines.children, false, 2.02);
        const labelOptions = (name) => ({
            size: new Vector2(2.4 * 2, 0.4 * 2),
            pxSize: new Vector2(300, 50).multiplyScalar(window['quality'] === 'very low' ? 0.7 : 1),
            background: { color: 'transparent' },
            text: {
                value: name,
                style: { size: `${35 * (window['quality'] === 'very low' ? 0.7 : 1)}px`, family: 'Nunito', color: PRIMARY_TEXT_COLOR.getStyle(), weight: '700' },
                lineHeight: 40 * (window['quality'] === 'very low' ? 0.7 : 1),
                align: 'left',
                autoWrappingHorizontal: true,
                margin: 10
            }
        });
        const labelsWrapper = this.addObject(new Object3D());
        ['380', '405', '430', '455'].forEach((name) => {
            const text = this.addObject(new TextComponent(labelOptions(name)), null, labelsWrapper);
            return text.uiObject;
        });
        ViewerModule.adjustObjects(labelsWrapper.children, true, 1.1, 0);
        labelsWrapper.position.set(-5.11, -0.13, -0.26);
        labelsWrapper.rotation.set(-1.56, 0, 0.4);
        const wavelengthLabel = this.addObject(new TextComponent(labelOptions('Wavelength')));
        wavelengthLabel.uiObject.position.set(-7, -0.17, -5.1);
        wavelengthLabel.uiObject.rotation.set(-1.56, 0, 0.4);
        const transmittanceLabel = this.addObject(new TextComponent(labelOptions('Transmittance')));
        transmittanceLabel.uiObject.position.set(-3.29, -0.17, -6.62);
        transmittanceLabel.uiObject.rotation.set(-1.56, 0, 0.4);
        const absorbanceLabel = this.addObject(new TextComponent(labelOptions('Absorbance')));
        absorbanceLabel.uiObject.position.set(0.91, -0.18, -8.35);
        absorbanceLabel.uiObject.rotation.set(-1.56, 0, 0.4);
        this.addObject(this.inputDisabler = new Mesh(new PlaneGeometry(10, 10), new MeshBasicMaterial({ visible: false })));
        this.inputDisabler.position.set(0.2597943563583277, 0.961983525893104, -1.7795831931707824);
        this.inputDisabler.rotation.set(-1.6103652816360692, -0.012978867055128645, 0.4087283956388127);
        this.actionController.on(ActionControllerEventName.click, this.inputDisabler, () => 0);
        this.inputs.forEach((input) => {
            input.input.on('onInputClicked', () => {
                this.activeInput = input.input;
                setTimeout(() => {
                    //
                    this.parentLevel.uiContainer.add(InputManager.keyboard.uiObject);
                    const keyboardObj = InputManager.keyboard.uiObject;
                    if (!Viewer.controls.zController) {
                        keyboardObj.position.set(-0.68, 0.1634, 4.762);
                        keyboardObj.rotation.set(-0.18, 0, 0);
                        keyboardObj.scale.set(.25, .25, .25);
                        // @ts-ignore
                        InputManager.keyboard.rightKeyboard.uiObject.position.x = 6;
                    }
                    else {
                        keyboardObj.position.set(-0.68, -1.9, 0);
                        keyboardObj.rotation.set(0, 0, 0);
                        keyboardObj.scale.set(.5, .5, .5);
                        // @ts-ignore
                        InputManager.keyboard.rightKeyboard.uiObject.position.x = 6;
                        // @ts-ignore
                        InputManager.keyboard.rightKeyboard.uiObject.position.z = 0;
                        // @ts-ignore
                        InputManager.keyboard.rightKeyboard.uiObject.rotation.set(0, 0, 0);
                    }
                });
            });
            input.input.on('entered', () => this.activeInput = null);
        });
        this.addObject(this.model = ResourcesManager.getModel('notebook'));
        this.model.getObjectByName('notebook_text').material = new MeshBasicMaterial({ color: 0xffffff });
        this.model.scale.multiplyScalar(10);
        this.model.position.set(0, -.5, 0);
        this.inputs.forEach(inputInfo => {
            inputInfo.input.uiObject.position.y /= 1.85;
            const borderInputSize = this.inputSize.clone();
            borderInputSize.add(new Vector2(this.inputSize.clone().x * 0.9, 0));
            // @ts-ignore
            inputInfo.inputBorder = new WindowComponent({
                size: borderInputSize.clone(),
                bordColor: PRIMARY_TEXT_COLOR.getHex(),
                background: 0xFFFFFF,
                bordWidth: 0.065,
                bordRadius: 0
            });
            // @ts-ignore
            inputInfo.input.addObject(inputInfo.inputBorder.uiObject);
            // @ts-ignore
            inputInfo.inputBorder.uiObject.position.x -= 0.65;
            inputInfo.input.on('entered', () => {
                inputInfo.input.isFocused = false;
                InputManager.hideKeyboard();
                this.animProperty(this.currActiveInput.inputBorder.uiObject.children[1].material, 'color', WINDOW_HEADER_TEXT_BACKGROUND_COLOR.clone(), PRIMARY_TEXT_COLOR.clone());
                setTimeout(() => this.currActiveInput = null, 300);
                this.fire('entered', new ParentEvent('', {
                    wavelength: inputInfo.wavelength,
                    type: inputInfo.type,
                    value: inputInfo.input.inputString,
                    input: inputInfo.input
                }));
            });
            inputInfo.input.on('onInputClicked', () => {
                if (this.currActiveInput) {
                    if (this.currActiveInput === inputInfo)
                        return;
                    this.animProperty(this.currActiveInput.inputBorder.uiObject.children[1].material, 'color', WINDOW_HEADER_TEXT_BACKGROUND_COLOR.clone(), PRIMARY_TEXT_COLOR.clone());
                }
                this.currActiveInput = inputInfo;
                // @ts-ignore
                this.animProperty(inputInfo.inputBorder.uiObject.children[1].material, 'color', PRIMARY_TEXT_COLOR.clone(), WINDOW_HEADER_TEXT_BACKGROUND_COLOR.clone());
            });
        });
    }
    animProperty(object, property, oldVal, newVal, duration = 300) {
        new TWEEN.Tween({ alpha: oldVal }).to({ alpha: newVal }, duration)
            .onUpdate((alpha) => {
            object[property].set(oldVal.clone().lerp(newVal, alpha));
        })
            .start();
    }
    flyToUser(toggle) {
        let newPosition, newRotation;
        if (toggle) {
            if (Viewer.controls.zController) {
                newPosition = new Vector3(-2, 0.3, 5.495);
                newRotation = new Quaternion().setFromEuler(new Euler(1.42, -0.39, -0.029));
            }
            else {
                newPosition = new Vector3(-2.04420649515801, 0.7313683240798204, 6.595685967381655);
                newRotation = new Quaternion().setFromEuler(new Euler(1.188003594964708, -0.2696960397967993, -0.5492791677666501));
            }
        }
        else {
            newPosition = new Vector3(-3.1466130678453097, -3.8176122189974904, 1.8579541226789735);
            newRotation = new Quaternion().setFromEuler(new Euler(0, -0.35993976090689883, 0));
        }
        const oldRotation = this.uiObject.quaternion.clone(), oldPosition = this.uiObject.position.clone();
        new TWEEN.Tween(this.uiObject.position).to(newPosition, 1500)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate((alpha) => {
            this.uiObject.quaternion.copy(oldRotation.clone().slerp(newRotation, alpha));
            if (Viewer.controls.zController) {
                if (toggle)
                    this.uiObject.scale.setScalar(0.15 + 0.1 * alpha);
                else
                    this.uiObject.scale.setScalar(0.3 - 0.1 * alpha);
            }
        })
            .onComplete(() => {
            this.inputDisabler.visible = !toggle;
        })
            .start();
    }
    reset() {
        this.uiObject.quaternion.setFromEuler(new Euler(0, -0.35993976090689883, 0));
        this.uiObject.position.set(-3.1466130678453097, -3.8176122189974904, 1.8579541226789735);
        this.activeInput = null;
        if (this.currActiveInput) {
            this.animProperty(this.currActiveInput.inputBorder.uiObject.children[1].material, 'color', WINDOW_HEADER_TEXT_BACKGROUND_COLOR.clone(), PRIMARY_TEXT_COLOR.clone());
            this.currActiveInput = null;
        }
        this.inputs.forEach(input => {
            input.input.clear();
            input.input.isFocused = false;
        });
    }
}
